import React, { Component } from 'react';
import { Provider } from 'react-redux';
import Helmet from 'react-helmet';
import { ConnectedRouter } from 'connected-react-router';
import Global from './Global';
import TopRouter from './TopRouter';
import { store, history } from './redux/store';

import './App.css';

class App extends Component {
    render() {
        console.info( `${ process.env.APP_NAME } v${ process.env.VERSION } ${ process.env.NODE_ENV }` );

        return (
            <Provider store={ store }>
                <Helmet titleTemplate='%s | The Desire Company' defaultTitle='The Desire Company'>
                    <meta name='description' content='The Desire Company is a content and media platform that introduces consumers to the best online classes, how-tos and product reviews available.' />
                    <meta property='og:description' content='The Desire Company is a content and media platform that introduces consumers to the best online classes, how-tos and product reviews available.' />
                    <meta property='og:image' content={ process.env.REACT_APP_HOST + '/icon.png' } />
                    <meta property='og:image:alt' content='Desire Company logo' />
                    <meta property='og:url' content={ process.env.REACT_APP_HOST + window.location.pathname.replace( 'puppeteer', '' ) } />
                    <meta property='og:site_name' content='The Desire Company' />
                    <meta property='og:title' content='The Desire Company' />
                    <meta property='og:type' content='website' />
                    <meta property='fb:app_id' content={ process.env.FACEBOOK_APP_ID } />
                    <meta name='twitter:card' content='summary_large_image' />
                    <meta name='twitter:site' content='@thedesireco' />
                    <meta name='twitter:title' content='The Desire Company' />
                    <meta name='twitter:image' content={ process.env.REACT_APP_HOST + '/icon.png'} />
                    <meta name='twitter:description' content='The Desire Company is a content and media platform that introduces consumers to the best online classes, how-tos and product reviews available.' />
                </Helmet>
                <ConnectedRouter history={ history }>
                    <TopRouter />
                </ConnectedRouter>
                <Global />
            </Provider>
        );
    }
}

export default App;
